import { render, staticRenderFns } from "./LogoUnsplashIcon.vue?vue&type=template&id=8af2f698&"
import script from "./LogoUnsplashIcon.vue?vue&type=script&lang=js&"
export * from "./LogoUnsplashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports